import { getReadableFileType, toBoolean } from './dataHelper';

const passwordRegex = /^((.){8,})$/i;
const phoneNumberRegex = /^(07(\d){8})$/g;
const urlRegex = /((https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/igm;

function isValidTextInput(value, strict = true, regex = /\w+/) {
  if (strict === true && !toBoolean(value)) {
    return false;
  }

  if (regex.test(value) === true || strict === false) {
    return true;
  }
  return false;
}

function isValidNumber(value, strictPattern = true) {
  const reg = new RegExp(strictPattern ? phoneNumberRegex : /\d+/g);
  //
  const is = reg.test(value);

  return is;
}

function isValidUrl(url) {
  const reg = new RegExp(urlRegex);

  const is = reg.test(url);

  return is;
}

function isValidEmail(email) {
  const emailStr = email;
  const emailRegexTest = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
    .test(emailStr);

  if (emailStr !== undefined) {
    if (emailStr.length > 0 && emailRegexTest) {
      return true;
    }
  }
  return false;
}

function isValidKenGenEmail(email) {
  const emailStr = email;
  const emailRegexTest = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@kengen\.co\.ke/g
    .test(emailStr);

  if (emailStr !== undefined) {
    if (emailStr.length > 0 && emailRegexTest) {
      return true;
    }
  }
  return false;
}

function isValidFile(file) {
  if (typeof file === 'object') {
    return !!getReadableFileType(file.type);
  }
  return !!getReadableFileType(file);
}

function isValidSelectInput(value) {
  if (typeof value === 'object') {
    return value.every((v) => v !== undefined);
  }

  return value !== undefined;
}

function passwordsMatch(password1, password2) {
  if (password1 === password2) {
    return true;
  }
  return false;
}

function isValidForm(form) {
  console.log('validating form: ', form);
  return true;
}

export default {
  isValidTextInput,
  isValidSelectInput,
  isValidEmail,
  isValidKenGenEmail,
  isValidNumber,
  isValidUrl,
  passwordsMatch,
  isValidFile,
  isValidForm,
  passwordRegex,
};
